module.exports = __webpack_public_path__ + "static/AllAboutBE-b039c315f1e83af498e77f220b97e554.png";